module.exports = __webpack_public_path__ + "static/img/m2.9ea7b72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m2.png
// module id = gfmp
// module chunks = 0